function getStoredCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

document.querySelectorAll('.cookies-popup').forEach((el) => {
  if (
    getStoredCookie(el.dataset.cookiesType) === undefined ||
    getStoredCookie(el.dataset.cookiesType) !== 'closed' ||
    el.dataset.mode === 'testing'
  ) {
    el.style.display = 'block';

    setTimeout(() => {
      el.classList.add('popup--animate');
    }, el.dataset.displayTime);
  }

  el.querySelector('.cookies-trigger').addEventListener('click', () => {
    el.classList.remove('popup--animate');

    setTimeout(() => {
      el.style.display = 'none';
    }, 3000);

    if (el.dataset.mode === 'enabled') {
      document.cookie = `${el.dataset.cookiesType}=closed; path=/; max-age=${60 * 60 * 24 * el.dataset.cookies}`;
    }
  });
});
